export const MS_BEFORE_RESET_LOADING_STATE = 100
export const ADD_AUDIT_NOTES_NEW_DIALOG = 'ADD_AUDIT_NOTES_NEW_DIALOG' as const
